import React from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import {
    mediumDesktop,
    tablet,
    hugeDesktop,
    largeDesktop,
    semiLargeDesktop,
} from 'helpers/utils/screensizes';


const FullWidthVideo = (props: any) => {
    const { content: sectionWithVideo } = props;
    const [isHugeDesktopSize] = useMediaQuery(hugeDesktop);
    const [isSemiLargeDesktopSize] = useMediaQuery(semiLargeDesktop);
    const [ismediumDesktopSize] = useMediaQuery(mediumDesktop);
    const [isLargeDesktopSize] = useMediaQuery(largeDesktop);

    if (!sectionWithVideo) {
        return null;
    }

    return (
        <div className="md:px-100 pt-60 pb-85 2xl:px-208">
            {sectionWithVideo?.title && 
            <div className="block text-28 font-medium leading-10 text-primary-black pb-20 xl:text-36 2xl:text-48 lg:leading-[3.25rem] text-center">{sectionWithVideo?.title}</div>
            }
            <div className="video-container flex justify-center">
                <iframe
                    src={sectionWithVideo?.video_link?.href}
                    width="100%"
                    loading="lazy"
                    height={
                        isHugeDesktopSize ? '720px' :
                        isSemiLargeDesktopSize ? '480px' :
                        ismediumDesktopSize ? '500px' :
                        isLargeDesktopSize ? '600px' :
                        '320px'
                    }
                ></iframe>
            </div>
        </div>
    )
};

export default FullWidthVideo;